/**
 * 酒店（门店）缓存 API 服务
 * 数据来源：后端缓存表 pms_hotel_cache
 * 接口：GET /api/hotel/list
 */

export interface PmsHotelCacheItem {
  id: number;
  name?: string;
  fullName?: string;
  code?: string;
  brandId?: number;
  brandName?: string;
  regionId?: number;
  regionName?: string;
  province?: number;
  city?: number;
  county?: number;
  onlineStatus?: number;
  status?: number;
  [key: string]: any;
}

export interface PmsHotelCacheListResponse {
  code: number;
  message?: string;
  msg?: string;
  data?: {
    total: number;
    list: PmsHotelCacheItem[];
  };
  meta?: any;
}

export interface PmsHotelCacheQueryParams {
  pageNum?: number;
  pageSize?: number;
  search?: string;
  brandId?: number;
  regionId?: number;
  regionCnId?: number;
  onlineStatus?: number;
  status?: number;
  id?: number;
  adminName?: string;
  isRestaurant?: number;
  isReportExclude?: number;
  startOnlineTime?: string;
  endOnlineTime?: string;
}

export type GetHotelListRequestOptions = {
  /** 为 true 时请求头带 no-cache，避免拉授权门店后名称列表仍走缓存 */
  bypassHttpCache?: boolean;
};

/**
 * 获取酒店列表（从 pms_hotel_cache）
 * 说明：走 apiClient 的 /api 前缀，开发环境通过 setupProxy 转发到后端 50045
 */
export async function getHotelList(
  params?: PmsHotelCacheQueryParams,
  requestOpts?: GetHotelListRequestOptions
): Promise<PmsHotelCacheListResponse> {
  const { apiClient } = await import('../config/netConfig');

  const queryParams = new URLSearchParams();
  if (params?.pageNum !== undefined) queryParams.append('pageNum', String(params.pageNum));
  if (params?.pageSize !== undefined) queryParams.append('pageSize', String(params.pageSize));
  if (params?.search) queryParams.append('search', params.search);
  if (params?.brandId !== undefined) queryParams.append('brandId', String(params.brandId));
  if (params?.regionId !== undefined) queryParams.append('regionId', String(params.regionId));
  if (params?.regionCnId !== undefined) queryParams.append('regionCnId', String(params.regionCnId));
  if (params?.onlineStatus !== undefined) queryParams.append('onlineStatus', String(params.onlineStatus));
  if (params?.status !== undefined) queryParams.append('status', String(params.status));
  if (params?.id !== undefined) queryParams.append('id', String(params.id));
  if (params?.adminName) queryParams.append('adminName', params.adminName);
  if (params?.isRestaurant !== undefined) queryParams.append('isRestaurant', String(params.isRestaurant));
  if (params?.isReportExclude !== undefined) queryParams.append('isReportExclude', String(params.isReportExclude));
  if (params?.startOnlineTime) queryParams.append('startOnlineTime', params.startOnlineTime);
  if (params?.endOnlineTime) queryParams.append('endOnlineTime', params.endOnlineTime);

  const basePath = '/hotel/list';
  const url = queryParams.toString() ? `${basePath}?${queryParams.toString()}` : basePath;

  const response = await apiClient.get<PmsHotelCacheListResponse>(url, {
    headers: requestOpts?.bypassHttpCache
      ? { "Cache-Control": "no-cache", Pragma: "no-cache" }
      : undefined,
  });
  return response.data;
}

